<template>
  <div>
    <app-cells><h1 class="title">CRM Analytics</h1></app-cells>
    <app-tabs :tabs="tabs_to_show" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'CRMAnalyticsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'crm-analytics-requests', label: 'Requests', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-managers-requests', label: 'Managers (Requests)', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-performance-requests', label: 'Performance (Requests)', roles: ['general_manager', 'marketing_supervisor'] },
        { name: 'crm-analytics-sales', label: 'Sales', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-managers-sales', label: 'Managers (Sales)', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-advertising', label: 'Advertising', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-urls', label: 'URL’s', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-urls-sales', label: 'URL’s (Sales)', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-regions', label: 'Regions', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-regions-sales', label: 'Regions (Sales)', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-clients-profile', label: 'Clients profile', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-expenses', label: 'Expenses', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        { name: 'crm-analytics-marketing-dashboard', label: 'Marketing Dashboard', roles: ['general_manager', 'marketing_supervisor'] },
        { name: 'crm-analytics-cohorts', label: 'Cohorts', roles: ['general_manager', 'marketing_supervisor'] },
        { name: 'crm-analytics-dashboard-builder', label: 'Dashboard Builder', roles: ['general_manager', 'marketing_supervisor'] },
        { name: 'crm-analytics-conversions', label: 'Conversions', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        // { name: 'crm-analytics-api', label: 'API', roles: ['general_manager', 'marketing_supervisor', 'marketing_assistant'] },
        // { name: 'crm-analytics-tour-dates', label: 'Tour dates' },
      ],
      tabs_to_show: [],
    }
  },
  created() {
    const tabs = []
    this.tabs.forEach(item => {
      if (!item.roles.length) {
        tabs.push(item)
        return
      }
      item.roles.forEach(role => {
        if (this.$store.state.userGroups.some(groupRole => groupRole.code === role)) tabs.push(item)
      })
    })
    this.tabs_to_show = [...new Set(tabs)]
  },
}
</script>
